import { GET_DOCUMENTS_API, POST_DOCUMENTS_API, ANALYSER_IA_DOCUMENT_API, RECHERCHE_DOCUMENTS_API, SUGGERER_TRANSMISSION_DOCUMENT_API, SHARE_DOCUMENTS_API, FAVORITE_DOCUMENT_API, TRACK_DOCUMENTS_CONSULT_API, TRANSITION_DOCUMENT_API, RESOUDRE_COURRIER_DOCUMENT_API, RELANCER_COURRIER_DOCUMENT_API, RESOUDRE_QUALITE_DOCUMENT_API, HISTORIQUE_DOCUMENT_API, CONSULTATIONS_DOCUMENT_API, VERSIONS_DOCUMENT_API, NEW_VERSION_DOCUMENT_API, CORRIGER_ET_RENVOYER_DOCUMENT_API, VERIFIER_INTEGRITE_DOCUMENT_API, DOCUMENT_META_API, GET_PARTAGES_RECUS_API, MARQUER_PARTAGE_LU_API, MARQUER_TOUS_PARTAGES_LUS_API, UPDATE_DOCUMENTS_API, DELETE_DOCUMENTS_API, TRASH_DOCUMENTS_API, RESTORE_DOCUMENT_API, FORCE_DELETE_DOCUMENT_API, A_TRAITER_DOCUMENTS_API, COURRIER_COMPTEURS_DOCUMENTS_API, PROCHAINE_REFERENCE_COURRIER_API, DECISION_CONGES_DOCUMENT_API, DECISION_PAIE_DOCUMENT_API, VERROUILLER_DOCUMENT_API, DEVERROUILLER_DOCUMENT_API, EDITION_WORD_DOCUMENT_API, ENREGISTRER_COPIE_WORD_DOCUMENT_API, DELETE_VERSION_DOCUMENT_API, PIECES_JOINTES_DOCUMENT_API, DELETE_PIECE_JOINTE_DOCUMENT_API } from "..";

/**
 * @param {File[]} piecesJointes - Fichiers supplémentaires déposés en même temps (ex: courrier + pièce qui l'accompagnait).
 */
export async function createDocument(data, file, piecesJointes = []) {
    const { url, ...meta } = POST_DOCUMENTS_API;

    const formData = new FormData();

    // Ajouter les données au FormData — on saute les valeurs undefined/null
    // (un champ optionnel non renseigné), sinon FormData les transforme en la
    // chaîne littérale "undefined"/"null", polluée en base côté serveur.
    for (const key in data) {
        if (data.hasOwnProperty(key) && data[key] !== undefined && data[key] !== null) {
            // Un tableau (ex: destinataires_ids) doit partir en plusieurs champs
            // "cle[]" pour que Laravel le reçoive comme un vrai tableau — un
            // simple append() le convertirait en chaîne "1,2,3" illisible côté validation.
            if (Array.isArray(data[key])) {
                data[key].forEach((valeur) => formData.append(`${key}[]`, valeur));
            } else {
                formData.append(key, data[key]);
            }
        }
    }

    if (file) {
        formData.append('file', file);
    }
    piecesJointes.forEach((piece) => formData.append('pieces_jointes[]', piece));

    const fetchOptions = {
        ...meta,
        body: formData,
    };

    return await fetch(url, fetchOptions);
}

/**
 * Analyse IA d'un fichier pas encore archivé — propose titre/résumé/référence/
 * texte extrait pour préremplir le formulaire (voir ArchiverDocumentModal.jsx/
 * OpenFolder.jsx). Ne persiste rien : la vraie création se fait ensuite via
 * createDocument().
 */
export async function analyserDocumentIa(file) {
    const { url, ...meta } = ANALYSER_IA_DOCUMENT_API;
    const formData = new FormData();
    formData.append('file', file);
    return await fetch(url, { ...meta, body: formData });
}

export async function rechercheDocuments(q) {
    const { url, ...meta } = RECHERCHE_DOCUMENTS_API;
    return await fetch(url + `?q=${encodeURIComponent(q)}`, { ...meta, credentials: 'include' })
}

/**
 * Suggestion IA du/des service(s) à qui transmettre un document déjà archivé
 * (voir DocView.jsx, panneau "Transmettre à un service").
 */
export async function suggererTransmission(id) {
    const { url, ...meta } = SUGGERER_TRANSMISSION_DOCUMENT_API;
    return await fetch(url + `/${id}/suggerer-transmission`, { ...meta, credentials: 'include' })
}

export async function getDocument(){
    const {url,...meta} = GET_DOCUMENTS_API;
    return await fetch(url, {...meta,credentials:'include'})
}

/**
 * Liens signés à durée limitée vers le fichier (affichage inline + téléchargement) —
 * show()/downloadVersion() n'acceptent plus que ces liens, pas de Bearer possible
 * sur une balise <img>/<iframe>/<a> (voir DocumentController::lienFichier()).
 */
export async function getDocumentLienFichier(id){
    const {url,...meta} = DOCUMENT_META_API;
    return await fetch(url+`/${id}/lien-fichier`, {...meta,credentials:'include'})
}

export async function getVersionLienFichier(id, versionId){
    const {url,...meta} = DOCUMENT_META_API;
    return await fetch(url+`/${id}/versions/${versionId}/lien-fichier`, {...meta,credentials:'include'})
}

/**
 * Supprime une ancienne version (fichier + ligne d'historique) — pour garder
 * un historique gérable sans attendre l'élagage automatique.
 */
export async function deleteVersion(id, versionId){
    const {url,...meta} = DELETE_VERSION_DOCUMENT_API;
    return await fetch(url+`/${id}/versions/${versionId}`, {...meta,credentials:'include'})
}

export async function getPiecesJointes(id){
    const {url,...meta} = PIECES_JOINTES_DOCUMENT_API;
    return await fetch(url+`/${id}/pieces-jointes`, {...meta,credentials:'include'})
}

export async function getPieceJointeLienFichier(id, pieceId){
    const {url,...meta} = DOCUMENT_META_API;
    return await fetch(url+`/${id}/pieces-jointes/${pieceId}/lien-fichier`, {...meta,credentials:'include'})
}

export async function deletePieceJointe(id, pieceId){
    const {url,...meta} = DELETE_PIECE_JOINTE_DOCUMENT_API;
    return await fetch(url+`/${id}/pieces-jointes/${pieceId}`, {...meta,credentials:'include'})
}

export async function consultationDocument(data){
    const {url,...meta} = TRACK_DOCUMENTS_CONSULT_API;
    return await fetch(url, {...meta,body:JSON.stringify(data),credentials:'include'})
}
/**
 * Partage un document avec un collègue (destinataire_utilisateur_id) ou par email
 * avec un particulier externe (email), avec un message optionnel.
 * @param {{destinataire_utilisateur_id?: number, email?: string, message?: string}} data
 */
export async function shareDocument(id, data){
    const {url,...meta} = SHARE_DOCUMENTS_API;
    return await fetch(url+`/${id}/share`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

export async function favoriDocument(id){
    const {url,...meta} = FAVORITE_DOCUMENT_API;
    return await fetch(url+`/${id}/favorite`, {...meta,credentials:'include'})
}

export async function defavoriDocument(id){
    const {url,...meta} = FAVORITE_DOCUMENT_API;
    return await fetch(url+`/${id}/unfavorite`, {...meta,credentials:'include'})
}
export async function countDocument(){
    const {url,...meta} = GET_DOCUMENTS_API;
    return await fetch(url+'/count', {...meta,credentials:'include'})
}

/**
 * @param {{nouveau_statut: string, motif?: string}} data
 */
export async function transitionDocument(id, data){
    const {url,...meta} = TRANSITION_DOCUMENT_API;
    return await fetch(url+`/${id}/transition`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

/**
 * Résout un courrier entrant (Payé/Prélèvement/Traité) et l'archive dans la
 * foulée — voir DocumentController::resoudreCourrier().
 * @param {{etat_courrier: string}} data
 */
export async function resoudreCourrier(id, data){
    const {url,...meta} = RESOUDRE_COURRIER_DOCUMENT_API;
    return await fetch(url+`/${id}/courrier/resoudre`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

/** Relance manuelle d'un courrier entrant "En attente" (voir DocumentController::relancerCourrier()). */
export async function relancerCourrier(id){
    const {url,...meta} = RELANCER_COURRIER_DOCUMENT_API;
    return await fetch(url+`/${id}/courrier/relancer`, {...meta,credentials:'include'})
}

/**
 * Résout un document Qualité & Risque ("Lu et approuvé"/"Lu et rejeté").
 * @param {{decision: 'approuve'|'rejete'}} data
 */
export async function resoudreQualite(id, data){
    const {url,...meta} = RESOUDRE_QUALITE_DOCUMENT_API;
    return await fetch(url+`/${id}/qualite/resoudre`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

export async function getDocumentHistorique(id){
    const {url,...meta} = HISTORIQUE_DOCUMENT_API;
    return await fetch(url+`/${id}/historique`, {...meta,credentials:'include'})
}

/**
 * Personnes ayant consulté le document (une entrée par utilisateur).
 */
export async function getDocumentConsultations(id){
    const {url,...meta} = CONSULTATIONS_DOCUMENT_API;
    return await fetch(url+`/${id}/consultations`, {...meta,credentials:'include'})
}

export async function verifierIntegriteDocument(id){
    const {url,...meta} = VERIFIER_INTEGRITE_DOCUMENT_API;
    return await fetch(url+`/${id}/verifier-integrite`, {...meta,credentials:'include'})
}

export async function getDocumentMeta(id){
    const {url,...meta} = DOCUMENT_META_API;
    return await fetch(url+`/${id}/meta`, {...meta,credentials:'include'})
}

export async function getPartagesRecus(limit = 6){
    const {url,...meta} = GET_PARTAGES_RECUS_API;
    return await fetch(url+`?limit=${limit}`, {...meta,credentials:'include'})
}

export async function marquerPartageLu(id){
    const {url,...meta} = MARQUER_PARTAGE_LU_API;
    return await fetch(url+`/${id}/marquer-lu`, {...meta,credentials:'include'})
}

export async function marquerTousPartagesLus(){
    const {url,...meta} = MARQUER_TOUS_PARTAGES_LUS_API;
    return await fetch(url, {...meta,credentials:'include'})
}

/**
 * @param {{category_id:number, type_document_id?:number, titre:string, auteur:string, resume:string, reference:string}} data
 */
/**
 * Renomme un document (titre cliquable de la fiche) — endpoint dédié, pour
 * ne pas renvoyer tout le formulaire d'archivage juste pour un nom.
 */
export async function renommerDocument(id, titre){
    const {url, headers, ...meta} = UPDATE_DOCUMENTS_API;
    return await fetch(url+`/${id}/titre`, {...meta, method:'PATCH', headers, body:JSON.stringify({titre}), credentials:'include'})
}

export async function updateDocument(id, data){
    const {url,...meta} = UPDATE_DOCUMENTS_API;
    return await fetch(url+`/${id}`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

export async function deleteDocument(id){
    const {url,...meta} = DELETE_DOCUMENTS_API;
    return await fetch(url+`/${id}`, {...meta,credentials:'include'})
}

/**
 * Documents dans la corbeille (supprimés mais pas encore purgés).
 */
export async function getTrash(){
    const {url,...meta} = TRASH_DOCUMENTS_API;
    return await fetch(url, {...meta,credentials:'include'})
}

export async function restoreDocument(id){
    const {url,...meta} = RESTORE_DOCUMENT_API;
    return await fetch(url+`/${id}/restore`, {...meta,credentials:'include'})
}

export async function forceDeleteDocument(id){
    const {url,...meta} = FORCE_DELETE_DOCUMENT_API;
    return await fetch(url+`/${id}/force`, {...meta,credentials:'include'})
}

export async function getDocumentVersions(id){
    const {url,...meta} = VERSIONS_DOCUMENT_API;
    return await fetch(url+`/${id}/versions`, {...meta,credentials:'include'})
}

/**
 * Remplace le fichier d'un document, en conservant l'ancien comme version.
 * @param {'majeure'|'mineure'} [typeVersion] - défaut 'mineure' côté serveur
 */
export async function uploadNewVersion(id, file, typeVersion){
    const {url,...meta} = NEW_VERSION_DOCUMENT_API;
    const formData = new FormData();
    formData.append('file', file);
    if (typeVersion) formData.append('type_version', typeVersion);
    return await fetch(url+`/${id}/versions`, {...meta,body:formData,credentials:'include'})
}

/**
 * Pose/relâche un verrou pessimiste sur le document, pour éviter que deux
 * personnes remplacent le même fichier en même temps.
 */
export async function verrouillerDocument(id){
    const {url,...meta} = VERROUILLER_DOCUMENT_API;
    return await fetch(url+`/${id}/verrouiller`, {...meta,credentials:'include'})
}

export async function deverrouillerDocument(id){
    const {url,...meta} = DEVERROUILLER_DOCUMENT_API;
    return await fetch(url+`/${id}/deverrouiller`, {...meta,credentials:'include'})
}

/**
 * Config signée (JWT) pour ouvrir un document .docx/.doc dans l'éditeur Word
 * en ligne (OnlyOffice) — pose au passage le même verrou pessimiste que
 * verrouillerDocument().
 */
export async function getEditionWordConfig(id){
    const {url,...meta} = EDITION_WORD_DOCUMENT_API;
    return await fetch(url+`/${id}/edition-word`, {...meta,credentials:'include'})
}

/**
 * Configuration OnlyOffice en LECTURE seule, pour l'aperçu de la fiche
 * document — ne pose aucun verrou et n'exige pas le droit d'édition, voir
 * DocumentController::apercuOffice().
 */
export async function getApercuOfficeConfig(id){
    const {url,...meta} = EDITION_WORD_DOCUMENT_API;
    return await fetch(url+`/${id}/apercu-office`, {...meta,credentials:'include'})
}

/**
 * Même chose que getEditionWordConfig(), mais pour ouvrir une ANCIENNE
 * version dans l'éditeur — enregistre toujours le résultat comme une copie
 * séparée (voir DocumentController::callbackOnlyOfficeVersion()).
 */
export async function getEditionVersionConfig(id, versionId){
    const {url,...meta} = EDITION_WORD_DOCUMENT_API;
    return await fetch(url+`/${id}/versions/${versionId}/edition-word`, {...meta,credentials:'include'})
}

/**
 * "Enregistrer une copie sous..." depuis l'éditeur Word — crée un nouveau
 * document (même dossier que la source) sans toucher à l'original. Déclenché
 * par l'évènement onRequestSaveAs d'OnlyOffice (voir EditionWord.jsx).
 * @param {{url: string, titre?: string}} data
 */
export async function enregistrerCopieWord(id, data){
    const {url,...meta} = ENREGISTRER_COPIE_WORD_DOCUMENT_API;
    return await fetch(url+`/${id}/enregistrer-copie-word`, {...meta,body:JSON.stringify(data),credentials:'include'})
}

/**
 * Permet au déposant (intervenant/bénéficiaire) de corriger lui-même un
 * document rejeté : remplace le fichier et le renvoie directement en
 * "Soumis" pour re-validation — sans passer par les droits internes.
 */
export async function corrigerEtRenvoyerDocument(id, file){
    const {url,...meta} = CORRIGER_ET_RENVOYER_DOCUMENT_API;
    const formData = new FormData();
    formData.append('file', file);
    return await fetch(url+`/${id}/corriger-et-renvoyer`, {...meta,body:formData,credentials:'include'})
}

/**
 * Enregistre la décision de l'employeur sur une demande de congés : remplace
 * le fichier par le PDF complété (section 3 incrustée côté client), fait
 * transitionner le statut, et déclenche l'envoi du PDF final par e-mail au
 * demandeur — voir DocumentController::decisionConges().
 * @param {FormData} formData - file, nouveau_statut, motif?, nom_signataire
 */
export async function envoyerDecisionConges(id, formData){
    const {url,...meta} = DECISION_CONGES_DOCUMENT_API;
    return await fetch(url+`/${id}/decision-conges`, {...meta,body:formData,credentials:'include'})
}

/**
 * Envoie la vraie fiche de paie en réponse à une "Demande de fiche de paie" :
 * remplace le fichier, range le document dans "Bulletin de paie" au nom du
 * salarié, et marque la demande traitée — voir DocumentController::decisionPaie().
 */
export async function envoyerDecisionPaie(id, formData){
    const {url,...meta} = DECISION_PAIE_DOCUMENT_API;
    return await fetch(url+`/${id}/decision-paie`, {...meta,body:formData,credentials:'include'})
}

/**
 * Documents à traiter bientôt : en attente de validation depuis longtemps,
 * ou proches de leur échéance de purge.
 */
export async function getDocumentsATraiter(){
    const {url,...meta} = A_TRAITER_DOCUMENTS_API;
    return await fetch(url, {...meta,credentials:'include'})
}

/**
 * Compteur des courriers entrants encore "En attente" — tuile du tableau de bord.
 */
export async function getCourrierCompteurs(){
    const {url,...meta} = COURRIER_COMPTEURS_DOCUMENTS_API;
    return await fetch(url, {...meta,credentials:'include'})
}

/**
 * Aperçu de la prochaine référence CRE-/CRS- (voir CourrierForm.jsx,
 * DocumentController::prochaineReferenceCourrier()) — appelé avant
 * l'archivage pour l'imprimer sur la fiche PDF générée côté sortant.
 * @param {'entrant'|'sortant'} sensCourrier
 * @param {string} [date] - date_reception ou date_envoi selon le sens
 */
export async function getProchaineReferenceCourrier(sensCourrier, date){
    const {url,...meta} = PROCHAINE_REFERENCE_COURRIER_API;
    const params = new URLSearchParams({ sens_courrier: sensCourrier, ...(date ? { date } : {}) });
    return await fetch(url + `?${params}`, {...meta,credentials:'include'})
}
